import { useEffect, useState } from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { BasePathProvider } from "components/Providers";
import { resetStatus } from "store/application/application-status";
import LoginForm from "./LoginForm";
import ApplicantInfo from "./ApplicantInfo";
import ApplicationStatusList from "./ApplicationStatusList";
import dayjs from "dayjs";
import LanguageToggle from "components/LanguageToggle";

export default function ApplicationStatus() {
  const { t } = useTranslation();
  const basePath = `application-status`;
  const dispatch = useDispatch();

  const [isAfterLottery, setIsAfterLottery] = useState(false);
  const { isVerified, instance } = useSelector(
    (state) => state.application.applicationStatus || {}
  );

  const schoolLotteryDate = instance?.application?.applicationSchools[0]?.school?.options?.lotteryDate;

  useEffect(() => {
    const hasLottery = dayjs().isAfter(dayjs(schoolLotteryDate));
    setIsAfterLottery(hasLottery);
  }, [instance]);

  const renderSchoolLogos = () => (
    <Paper
      sx={{
        gap: 1,
        display: "flex",
        justifyContent: "center",
        alignSelf: "center",
        p: 1,
        borderRadius: 2,
        flexWrap: "wrap",
      }}
      elevation={0}
    >
      <img src="https://ils.sfo2.digitaloceanspaces.com/var/www/html/2025/08/28135110/iLearn-Icon-Bergen-Alternate.jpg" alt="Bergen Icon" style={{ width: "52px" }} />
      <img src="https://ils.sfo2.digitaloceanspaces.com/var/www/html/2025/08/28135129/iLearn-Icon-Passaic-Alternate.jpg" alt="Passaic Icon" style={{ width: "52px" }} />
      <img src="https://ils.sfo2.digitaloceanspaces.com/var/www/html/2025/08/28135239/iLearn-Icon-Paterson-Alternate.jpg" alt="Paterson Icon" style={{ width: "52px" }} />
      <img src="https://ils.sfo2.digitaloceanspaces.com/var/www/html/2025/08/28135157/iLearn-Icon-Hudson-Alternate.png" alt="Hudson Icon" style={{ width: "52px" }} />
      <img src="https://ils.sfo2.digitaloceanspaces.com/var/www/html/2025/09/11112834/iLearn-Icon-Bronx-Alternate.png" alt="Bronx Icon" style={{ width: "52px" }} />
    </Paper>
  );

  if (!isVerified || !instance) {
    return (
      <BasePathProvider value={basePath}>
        <LoginForm />
      </BasePathProvider>
    );
  }

  return (
    <BasePathProvider value={basePath}>
      <Box sx={{ minHeight: "100vh", bgcolor: "background.default", p: 2 }}>
        <Box sx={{ width: "100%", mx: "auto" }}>
          <Box
            sx={{
              backgroundColor: "background.paper",
              borderRadius: 2,
              boxShadow: 1,
              p: 2,
              mb: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            <Typography variant="h4" sx={{ fontWeight: 400 }}>
              {t("Application Status")}
            </Typography>

            {renderSchoolLogos()}
          </Box>

          <ApplicantInfo applicantInfo={instance.application} />


          <Box sx={{ mt: 1 }}>
            <ApplicationStatusList applicationData={instance.application} currentlyProcessing={instance.currentlyProcessing} afterLottery={isAfterLottery} schoolLotteryDate={schoolLotteryDate} />
          </Box>

          <Box
            sx={{
              mt: 2,
              display: "flex",
              justifyContent: "center",
              gap: 1,
              flexWrap: "wrap",
            }}
          >

            <Button
              variant="text"
              sx={{ color: "text.secondary", fontWeight: 900 }}
              onClick={() => dispatch(resetStatus())}
            >
              {t("Check Another Applicant")}
            </Button>
          </Box>
        </Box>
        <Paper sx={{ position: 'fixed', right: 16, bottom: 16, zIndex: 1300 }}>
          <LanguageToggle />
        </Paper>
      </Box>
    </BasePathProvider>
  );
}
